import React from 'react';
import { Modal, Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import './FormModal.css';

const FormModal = ({
    title,
    visible,
    onCancel,
    onSubmit,
    loading = false,
    form,
    children,
    okText,
    cancelText,
    width = 700,
    className = '',
    ...rest
}) => {
    const { t } = useTranslation();
    const submitText = okText || t('submit');
    const cancelButtonText = cancelText || t('cancel');

    const handleOk = () => {
        form.validateFields().then((values) => {
            onSubmit(values);
        });
    };

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            onOk={handleOk}
            confirmLoading={loading}
            okText={submitText}
            cancelText={cancelButtonText}
            width={width}
            className={`form-modal ${className}`}
            okButtonProps={{
                className: 'form-modal-submit-btn',
            }}
            cancelButtonProps={{
                className: 'form-modal-cancel-btn',
            }}
            destroyOnClose
            centered
            {...rest}
        >
            <Form form={form} layout="vertical" className="form-modal-form">
                {children}
            </Form>
        </Modal>
    );
};

export default FormModal;
